import activityApi from '@/api/activity.api'

export const activityService = (function () {
  'use strict'

  /**
   * Devuelve los datos de las actividades de una empresa
   */
  async function getAllByEnterpriseId(enterpriseId) {
    try {
      const response = await activityApi.getAllByEnterpriseId(enterpriseId)
      return response.data
    } catch (exception) {
      console.error(exception)
      return false
    }
  }

  /**
   * Devuelve las actividades de una empresa y un tipo de equipo en particular
   */
  async function getAllByEnterpriseIdAndTypeId(enterpriseId, typeId) {
    try {
      const response = await activityApi.getAllByEnterpriseIdAndTypeId(enterpriseId, typeId)
      return response.data
    } catch (exception) {
      console.error(exception)
      return false
    }
  }

  /**
   * Devuelve las actividades de una empresa, sector y un tipo de equipo en particular
   */
  async function getAllByEnterpriseIdSectorIdAndTypeId(enterpriseId, sectorId, typeId) {
    try {
      const response = await activityApi.getAllByEnterpriseIdSectorIdAndTypeId(enterpriseId, sectorId, typeId)
      return response.data
    } catch (exception) {
      console.error(exception)
      return false
    }
  }

  return {
    getAllByEnterpriseId,
    getAllByEnterpriseIdAndTypeId,
    getAllByEnterpriseIdSectorIdAndTypeId,
  }

})()
